import { render } from "./BatchParticipantsListByUser.vue?vue&type=template&id=64e94d5c&scoped=true"
import script from "./BatchParticipantsListByUser.vue?vue&type=script&lang=js"
export * from "./BatchParticipantsListByUser.vue?vue&type=script&lang=js"

import "./BatchParticipantsListByUser.vue?vue&type=style&index=0&id=64e94d5c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard_client/dashboard_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e94d5c"]])

export default __exports__